import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { GET_EXPENSE_PAGINATION } from "../Schema/Expense";

const useGetExpensePagination = ({ type, fromDate, toDate }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const { refetch } = useQuery(GET_EXPENSE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      type: type?.id ?? "",
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    },
    onCompleted: ({ getExpensePagination }) => {
      // console.log("getExpensePagination :", getExpensePagination);
      setTableData(getExpensePagination?.data);
      setPaginationData(getExpensePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  // const handleSearch = (e) => {
  //   setPage(1);
  //   setKeyword(e.target.value);
  // };

  useEffect(() => {
    refetch();
  }, [page, type?.id, fromDate, toDate]);

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    handleLimit,
    // handleSearch,
    paginationData,
  };
};

export default useGetExpensePagination;
